<template>
<!-- RegionsMap -->
  <div class="row">
    <div class="col-sm-12">
      <div class="hidden"><label for="">{{computeMapData}}</label></div>
      <div class="chart-wrapper" style="border: 0;">
        <div v-show="!dataAvailable" class="chart-has-no-data">
              <img src="static/img/no_data.svg" style="">
              <!-- <b-notification type="is-custom" :active.sync="chartHasNoData">
                <strong>Info! &nbsp;</strong> No data available
              </b-notification> -->
        </div>
        <div v-show="dataAvailable" class="chart-stage">
          <v-icon v-tooltip.top="'Expand chart'" @click="expandChart=true" class="expand-icon-highmap">zoom_out_map</v-icon>
          <!-- hello -->
          <highmaps style="z-index:0;" :options="options" ref="highmaps"></highmaps>
        </div>
      </div>
    </div>
    <b-modal :active.sync="expandChart" has-modal-card>
      <form action="">
          <div class="modal-card">
            <header class="modal-card-head" style="text-align:center;">
                <p class="modal-card-title">{{indicatorName}}</p>
            </header>
            <section>
              <highmaps style="z-index:0;" :options="options" ref="highmaps"></highmaps>
            </section>
            <footer class="modal-card-foot">
                <button class="button is-danger pull-right" type="button" @click="expandChart=false">CLOSE</button>
            </footer>
          </div>
        </form>
      </b-modal>
  </div>
</template>

<script>
  import map_data from '@/assets/js-on/nigmap_regions_state_data';

  export default {
    name: 'regionstatesMap',
    components: {},
    data() {
      return {
        // lsData: JSON.parse(this.$ls.get('car_other_dataset')),
        mapPlotData: null,
        expandChart: false,
        dataAvailable: false,
        indicatorName: '',
        options: {
          chart: {
            map: 'countries/ng/ng-all',
            borderColor: '#335cad',
            height: 438
          },

          colors: ['#2f7ed8', '#0d233a', '#8bbc21', '#910000', '#1aadce',
            '#492970', '#f28f43', '#77a1e5', '#c42525', '#a6c96a'],

          credits: {
            enabled: false,
            text: 'Map of Nigeria'
          },

          title: {
            text: 'Loading...',
            style: {
              fontSize: '16px',
              fontFamily: '"Open Sans", sans-serif',
              fontWeight: '600'
            }
          },

          subtitle: {
            text: "Loading...",
            style: {
              fontSize: '11px',
              fontFamily: '"Open Sans", sans-serif',
              fontWeight: 'normal'
            }
          },

          exporting: {
            csv: {
              dateFormat: '%Y-%m-%d'
            }
          },

          mapNavigation: {
            // enableDoubleClickZoomTo: true,
            enabled: true,
            buttonOptions: {
              verticalAlign: 'middle',
              align: 'right'
            }
          },

          legend: {
            enabled: false,
            layout: 'vertical',
            align: 'right'
          },
          colorAxis: {
            // min: 0,
            // max: 100,
            minColor: '#E6E7E8',
            maxColor: '#114663'
          },

          plotOptions: {
            map: {
              allAreas: false,
              mapData: map_data, // Highcharts.maps['countries/ng/ng-all'],
              states: {
                hover: {
                  color: '#BADA55'
                }
              },
              joinBy: "hc-key",
              dataLabels: {
                enabled: true,
                //format: '{point.name}',
                color: '#FFFFFF',
                formatter: function () {
                  if (this.point.value) {
                    return this.point.name;
                  }
                }
              },
              tooltip: {
                headerFormat: '<b>{series.name}</b><br>',
                pointFormat: '{point.name}: <b>{point.value}</b>'
              }
            }
          },
          series: [],
          exporting: {
              buttons: {
                  contextButton: {
                    menuItems: [
                      "printChart",
                      "separator",
                      "downloadPNG",
                      "downloadJPEG",
                      "downloadPDF",
                      "downloadSVG",
                      "separator",
                      "downloadCSV",
                      "downloadXLS",
                      //"viewData",
                      "openInCloud"
                    ],
                    symbol: 'download',
                    // symbolStrokeWidth: 2,
                    // symbolFill: '#330033',
                    // symbolStroke: '#b3d4fc'
                  }
              }
          }
        }
      }
    },
    methods: {
      // for creating a color shade for states in same region
      // based on their values.
      shadeColor(color, percent) {
        // convert color codes to integers with radix 16
        var R = parseInt(color.substring(1, 3), 16);
        var G = parseInt(color.substring(3, 5), 16);
        var B = parseInt(color.substring(5, 7), 16);

        // scale to 255
        R = parseInt(R * ((100 + percent) / 100));
        G = parseInt(G * ((100 + percent) / 100));
        B = parseInt(B * ((100 + percent) / 100));

        // readjust scale
        R = R > 0 ? (R < 255 ? R : R - 255) : R + 255;
        G = G > 0 ? (G < 255 ? G : G - 255) : G + 255; // (G>0)?G: R+255;
        B = B > 0 ? (B < 255 ? B : B - 255) : B + 255;

        var RR = ((R.toString(16).length == 1) ? "0" + R.toString(16) : R.toString(16));
        var GG = ((G.toString(16).length == 1) ? "0" + G.toString(16) : G.toString(16));
        var BB = ((B.toString(16).length == 1) ? "0" + B.toString(16) : B.toString(16));

        return "#" + RR + GG + BB;
      },
      plotMap() {
        this.options.series = []
        if (!this.mapPlotData) {
          return;
        }
        // var map = map_data;
        var tempMaxValue = []
        var regionStatesMapProp = map_data
        console.log(map_data);
        
        for (var value in this.mapPlotData) {
          if (this.mapPlotData.hasOwnProperty(value)) {
            tempMaxValue.push(this.mapPlotData[value])
          }
        }
        var maxValue = Math.max.apply(null, tempMaxValue);
        var color = ["#83CFDB", "#EB928F", "#89D880", "#7D8ADE", "#F872A0", "#FFFF17"];
        // iterate over the 6 regions

        regionStatesMapProp.map((regionArray, index) => {
          regionArray.color = color[index];
          regionArray.data.map((stateInRegion, index2) => {
            stateInRegion.value = this.mapPlotData[stateInRegion.name];
            if (maxValue > 100) {
              var percentageValue = (stateInRegion.value / (Math.ceil(maxValue) + 100)) * 100
              stateInRegion.color = this.shadeColor(color[index], -percentageValue)
            }
            else {
              stateInRegion.color = this.shadeColor(color[index], -(stateInRegion.value))
            }

          });
          this.options.series.push(regionArray);
          //Check if the states has data
          for(var i in regionArray.data){
            if(regionArray.data[i].value > 0){
              this.dataAvailable = true;
              break;
            } else {
              this.dataAvailable = false;
            }
          }
          // regionsArray.data.map((obj,count) => {
          //   if(obj.value > 0){
          //     this.dataAvailable = true;
          //     break;
          //   }
          // })
        });
      }
    },
    computed: {
      computeMapData() {
        var ngMapData = this.$store.getters.getCARngMapData;
        
        console.log(ngMapData);
        
        this.mapPlotData = ngMapData[0];
        this.options.title.text = ngMapData[1];
        this.indicatorName = ngMapData[1];
        this.options.subtitle.text = ngMapData[2] + '-' + ngMapData[3];
        //this.options.series[0].name = ngMapData[2];
        // this.plotMap()
        return "Nigeria Map";
      }
    },
    updated() {
    },
    mounted() {
      // this.plotMap();
    },

    watch: {
      indicatorName(val){
        this.plotMap();
      }
    }
  }
</script>

<style>

</style>



// WEBPACK FOOTER //
// region_states.vue?3e7ec7e7